import {
  EnvironmentRequestProduct,
  EnvironmentState,
  PolicyProduct,
  ProductBinary
} from 'vrlcm-gui-types';
import * as Constants from '../../../constants/action-constants';
export interface InitializeStepSelectProduct {
  type: Constants.INITIALIZE_STEP_SELECT_PRODUCT;
}

export interface InitializeStepSelectProductSuccess {
  type: Constants.INITIALIZE_STEP_SELECT_PRODUCT_SUCCESS;
  payload: {
    products: PolicyProduct[];
    binaryMappings: ProductBinary[];
    existingVidm?: EnvironmentRequestProduct;
    existingVcfDeployedProductIds: string[];
  };
}

export interface InitializeStepSelectProductFailed {
  type: Constants.INITIALIZE_STEP_SELECT_PRODUCT_FAILED;
  payload: {
    errorMessage: string;
  };
}

export interface SubmitStepSelectProduct {
  type: Constants.SUBMIT_STEP_SELECT_PRODUCT;
  payload: {
    state: EnvironmentState;
  };
}

export type StepSelectProductAction =
  | InitializeStepSelectProduct
  | InitializeStepSelectProductFailed
  | InitializeStepSelectProductSuccess
  | SubmitStepSelectProduct;

export const initializeStepSelectProduct = (): InitializeStepSelectProduct => ({
  type: Constants.INITIALIZE_STEP_SELECT_PRODUCT
});

export const initializeStepSelectProductSuccess = (
  products: PolicyProduct[],
  binaryMappings: ProductBinary[],
  existingVcfDeployedProductIds: string[],
  existingVidm?: EnvironmentRequestProduct
): InitializeStepSelectProductSuccess => ({
  payload: {
    products,
    binaryMappings,
    existingVidm,
    existingVcfDeployedProductIds
  },
  type: Constants.INITIALIZE_STEP_SELECT_PRODUCT_SUCCESS
});

export const initializeStepSelectProductFailed = (
  errorMessage: string
): InitializeStepSelectProductFailed => ({
  type: Constants.INITIALIZE_STEP_SELECT_PRODUCT_FAILED,
  payload: { errorMessage }
});

export const submitStepSelectProduct = (
  state: EnvironmentState
): SubmitStepSelectProduct => ({
  payload: { state },
  type: Constants.SUBMIT_STEP_SELECT_PRODUCT
});
